import Vue from 'vue';
import VueAnime from 'vue-animejs';
import App from './App.vue';
import router from './router';

import '@/theme/global.scss';
import '../public/fonts/icons/icons.css';

Vue.use(VueAnime);

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
